import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { ToastService } from '../toast.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-create-settlement-invoice',
  templateUrl: './create-settlement-invoice.component.html',
  styleUrls: ['./create-settlement-invoice.component.scss'],
})
export class CreateSettlementInvoiceComponent {

  loader: boolean;
  tDate;
  enddate;
  startdate;
  minDate = new Date(); 
  fDate;
  dateFormat;
  constructor(public service: ApiService,
    public handler: HandlerService,
    public toast: ToastService,
    public router: Router,
    public auth: AuthService
    ) { }
  
  ionViewWillEnter(){
    this.dateFormat = this.auth.getDateformat();
  }
  
  startDate(){
    this.fDate=this.returnDate(this.startdate) + ' ' + '00:00:00';
  }

  endDate(){
    this.tDate=this.returnDate(this.enddate) +' '+ '23:59:59';
  }

  generate(){
    this.loader = true;
    this.service.generateInvoiceByDate(this.fDate,this.tDate).subscribe((res: any) => {
      this.handler.res("Invoice Generated Successfully")
      this.router.navigate(['/admin-invoice']);
    this.loader = false;
  },err => {
    this.loader = false;
    this.handler.err(err);
   })
  }

  returnDate(data) {
     let date = data.getDate();
     date = date < 10 ? '0' + date : date;
    let month = data.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let year = data.getFullYear();
    return year + '-' + month + '-' + date;
  }
  ionViewWillLeave(){
this.startdate = undefined;
this.enddate = undefined;
  sessionStorage.removeItem('orgId')
  }

}
